var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXwc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.327 11.894 4.029 8.577V8H8.57l2.957 9.808L13.979 8h3.318l2.813 9.447L22.49 8h5.01l-.971 3.894h4.47v2.74h-5.048l-.65 1.299H31v2.812h-6.49l-2.597 5.265H18.74l-2.884-8.077-2.885 8.077h-3.46l-2.092-5.265H1v-2.812h5.625l-.505-1.298H1v-2.74h4.327z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXwc);
export default __webpack_public_path__ + "static/media/XWC.dc042ca551ab2e46a64a630f8a4772ed.svg";
export { ForwardRef as ReactComponent };